exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-grey[data-v-382d34d7]{background:grey;color:#fff}label[data-v-382d34d7]{margin-bottom:10px!important}.pill[data-v-382d34d7],label[data-v-382d34d7]{font-weight:700}.pill[data-v-382d34d7]{display:inline-block;padding:5px 10px;border-radius:999px;font-size:14px;text-align:center;color:#fff}.pill-green[data-v-382d34d7]{background-color:green}.pill-red[data-v-382d34d7]{background-color:red}", ""]);

// exports
